export const css = {
    root: '_8hZGHl6p',
    question: '_1WzkPv65',
    actions: '_3WPQARhq',
    oneaction: '_1YdnuvHw',
    responseRoot: '_2zyoiIIV',
    essayList: '_2F-bLaX7',
    selectedEssay: 'QTh1kWSF',
    completedMemo: '_2OuaA2sW',
    essayListHead: 'oNZEmFWi',
    essayItem: '_3-JO4ygC',
    selectedEssayItem: '_2txrFebx',
    essayPane: 'Gg4LQrbs',
    essayUser: 'N8sRM91D',
    essayDate: '_1FRqaOyr',
    essayFragment: '_2eL63xEG',
    essayAnswer: '_270kMIbj',
    essayComments: 'r2Dx1PZp',
    commentEditor: '_396h9UQW',
    comment: '_269ewDes',
    commentUser: '_3LEGyITA',
    commentDate: '_1tId5Tiv',
    commentText: '_27ZOWMH7',
    areYouSure: 'ebuaDrGE',
    sureHeading: '_27kf6E8w',
    sureBody: '_1o-y-i2H',
    sureButtons: 'U-w2F8mG',
    ' _key': 'quiz-widgets/discussion'
};
export default css;
